import { useState } from 'react';
import { useStore } from '@store/index';
import { useObserver } from 'mobx-react';
import { useIsomorphicLayoutEffect } from '@lib/hooks'
import { useLike } from '@widget/post/hooks/like'

const useUserStore = () => {
  const { userStore } = useStore();
  return useObserver(() => userStore)
}

export const usePostLike = ({
  isLoved: defaultIsLoved,
  likeCount: defaultLikeCount,
  postData,
  id
}) => {
  const userStore = useUserStore();
  const [likeCount, setLikeCount] = useState(defaultLikeCount);
  const [isLoved, setIsLoved] = useState(defaultIsLoved);
  const { like } = useLike({
    userStore,
    itemData: postData,
    setCurLikeCount: setLikeCount,
    setIsLoved,
    isLoved,
    curLikeCount: likeCount
  })
  useIsomorphicLayoutEffect(() => {
    setLikeCount(defaultLikeCount)
    setIsLoved(defaultIsLoved)
  }, [defaultLikeCount, defaultIsLoved, id])
  return {
    likeCount,
    isLoved,
    like
  }
}
